import React, { useState } from 'react';
import { Plus, ArrowUpRight, ArrowDownRight, Repeat, Wallet, DollarSign, PiggyBank } from 'lucide-react';
const Wallets = () => {
  const [activeTab, setActiveTab] = useState('wallets');
  const [showFundModal, setShowFundModal] = useState(false);
  const [showTransferModal, setShowTransferModal] = useState(false);
  const [showExchangeModal, setShowExchangeModal] = useState(false);
  // Mock data for demonstration
  const wallets = [{
    id: 1,
    currency: 'USD',
    balance: 2540.5,
    code: 'USD'
  }, {
    id: 2,
    currency: 'GBP',
    balance: 1250.75,
    code: 'GBP'
  }, {
    id: 3,
    currency: 'NGN',
    balance: 450000.0,
    code: 'NGN'
  }, {
    id: 4,
    currency: 'ZAR',
    balance: 18500.25,
    code: 'ZAR'
  }, {
    id: 5,
    currency: 'GHS',
    balance: 7800.0,
    code: 'GHS'
  }];
  const recentTransactions = [{
    id: 1,
    type: 'credit',
    description: 'Wallet Funding',
    amount: 500,
    currency: 'USD',
    date: '2023-06-15',
    wallet: 'USD Wallet'
  }, {
    id: 2,
    type: 'debit',
    description: 'Transfer to GBP Wallet',
    amount: 200,
    currency: 'USD',
    date: '2023-06-14',
    wallet: 'USD Wallet'
  }, {
    id: 3,
    type: 'credit',
    description: 'Exchange from USD',
    amount: 158.4,
    currency: 'GBP',
    date: '2023-06-14',
    wallet: 'GBP Wallet'
  }, {
    id: 4,
    type: 'debit',
    description: 'Virtual Card Funding',
    amount: 100,
    currency: 'USD',
    date: '2023-06-12',
    wallet: 'USD Wallet'
  }, {
    id: 5,
    type: 'credit',
    description: 'Bank Transfer',
    amount: 1000,
    currency: 'USD',
    date: '2023-06-10',
    wallet: 'USD Wallet'
  }];
  const exchangeRates = {
    USD: {
      GBP: 0.79,
      NGN: 815.75,
      ZAR: 18.65,
      GHS: 12.45
    },
    GBP: {
      USD: 1.26,
      NGN: 1030.25,
      ZAR: 23.55,
      GHS: 15.7
    },
    NGN: {
      USD: 0.00123,
      GBP: 0.00097,
      ZAR: 0.023,
      GHS: 0.015
    },
    ZAR: {
      USD: 0.054,
      GBP: 0.042,
      NGN: 43.74,
      GHS: 0.67
    },
    GHS: {
      USD: 0.08,
      GBP: 0.064,
      NGN: 65.52,
      ZAR: 1.5
    }
  };
  const getCurrencySymbol = (code: string) => {
    const symbols: {
      [key: string]: string;
    } = {
      USD: '$',
      GBP: '£',
      NGN: '₦',
      ZAR: 'R',
      GHS: '₵'
    };
    return symbols[code] || code;
  };
  return <div className="py-6" data-id="element-860">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8" data-id="element-861">
        <h1 className="text-2xl font-semibold text-gray-900" data-id="element-862">Wallets</h1>
        <p className="mt-1 text-sm text-gray-500" data-id="element-863">
          Manage your multi-currency wallets
        </p>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 mt-6" data-id="element-864">
        {/* Tabs */}
        <div className="border-b border-gray-200" data-id="element-865">
          <nav className="-mb-px flex space-x-8" data-id="element-866">
            <button onClick={() => setActiveTab('wallets')} className={`${activeTab === 'wallets' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'} whitespace-nowrap pb-4 px-1 border-b-2 font-medium text-sm`} data-id="element-867">
              My Wallets
            </button>
            <button onClick={() => setActiveTab('transactions')} className={`${activeTab === 'transactions' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'} whitespace-nowrap pb-4 px-1 border-b-2 font-medium text-sm`} data-id="element-868">
              Transactions
            </button>
            <button onClick={() => setActiveTab('exchange')} className={`${activeTab === 'exchange' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'} whitespace-nowrap pb-4 px-1 border-b-2 font-medium text-sm`} data-id="element-869">
              Currency Exchange
            </button>
          </nav>
        </div>
        {/* Wallets Tab */}
        {activeTab === 'wallets' && <div className="mt-6" data-id="element-870">
            <div className="flex justify-between items-center mb-6" data-id="element-871">
              <h2 className="text-lg font-medium text-gray-900" data-id="element-872">
                Your Wallets
              </h2>
              <button onClick={() => setShowFundModal(true)} className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-873">
                <Plus className="h-5 w-5 mr-2" data-id="element-874" /> Add Funds
              </button>
            </div>
            <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-875">
              {wallets.map(wallet => <div key={wallet.id} className="bg-white overflow-hidden shadow rounded-lg" data-id="element-876">
                  <div className="p-5" data-id="element-877">
                    <div className="flex items-center" data-id="element-878">
                      <div className="flex-shrink-0" data-id="element-879">
                        <div className="h-12 w-12 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 font-bold" data-id="element-880">
                          {wallet.currency}
                        </div>
                      </div>
                      <div className="ml-5 w-0 flex-1" data-id="element-881">
                        <dl data-id="element-882">
                          <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-883">
                            {wallet.currency} Wallet
                          </dt>
                          <dd data-id="element-884">
                            <div className="text-lg font-medium text-gray-900" data-id="element-885">
                              {getCurrencySymbol(wallet.code)}{' '}
                              {wallet.balance.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        })}
                            </div>
                          </dd>
                        </dl>
                      </div>
                    </div>
                  </div>
                  <div className="bg-gray-50 px-5 py-3 flex justify-between" data-id="element-886">
                    <button onClick={() => setShowFundModal(true)} className="text-sm font-medium text-blue-700 hover:text-blue-900" data-id="element-887">
                      Fund
                    </button>
                    <button onClick={() => setShowTransferModal(true)} className="text-sm font-medium text-blue-700 hover:text-blue-900" data-id="element-888">
                      Transfer
                    </button>
                    <button onClick={() => setShowExchangeModal(true)} className="text-sm font-medium text-blue-700 hover:text-blue-900" data-id="element-889">
                      Convert
                    </button>
                  </div>
                </div>)}
            </div>
            {/* Quick Actions */}
            <div className="mt-8" data-id="element-890">
              <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-891">
                Quick Actions
              </h3>
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-3" data-id="element-892">
                <button onClick={() => setShowFundModal(true)} className="bg-white overflow-hidden shadow rounded-lg p-5 hover:bg-gray-50 transition-colors" data-id="element-893">
                  <div className="flex items-center" data-id="element-894">
                    <div className="flex-shrink-0" data-id="element-895">
                      <div className="h-10 w-10 rounded-full bg-green-100 flex items-center justify-center text-green-600" data-id="element-896">
                        <DollarSign className="h-5 w-5" data-id="element-897" />
                      </div>
                    </div>
                    <div className="ml-4" data-id="element-898">
                      <h4 className="text-base font-medium text-gray-900" data-id="element-899">
                        Add Funds
                      </h4>
                      <p className="text-sm text-gray-500" data-id="element-900">
                        Fund your wallet via bank or card
                      </p>
                    </div>
                  </div>
                </button>
                <button onClick={() => setShowTransferModal(true)} className="bg-white overflow-hidden shadow rounded-lg p-5 hover:bg-gray-50 transition-colors" data-id="element-901">
                  <div className="flex items-center" data-id="element-902">
                    <div className="flex-shrink-0" data-id="element-903">
                      <div className="h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600" data-id="element-904">
                        <Wallet className="h-5 w-5" data-id="element-905" />
                      </div>
                    </div>
                    <div className="ml-4" data-id="element-906">
                      <h4 className="text-base font-medium text-gray-900" data-id="element-907">
                        Transfer
                      </h4>
                      <p className="text-sm text-gray-500" data-id="element-908">
                        Send money between wallets
                      </p>
                    </div>
                  </div>
                </button>
                <button onClick={() => setShowExchangeModal(true)} className="bg-white overflow-hidden shadow rounded-lg p-5 hover:bg-gray-50 transition-colors" data-id="element-909">
                  <div className="flex items-center" data-id="element-910">
                    <div className="flex-shrink-0" data-id="element-911">
                      <div className="h-10 w-10 rounded-full bg-purple-100 flex items-center justify-center text-purple-600" data-id="element-912">
                        <Repeat className="h-5 w-5" data-id="element-913" />
                      </div>
                    </div>
                    <div className="ml-4" data-id="element-914">
                      <h4 className="text-base font-medium text-gray-900" data-id="element-915">
                        Exchange
                      </h4>
                      <p className="text-sm text-gray-500" data-id="element-916">
                        Convert between currencies
                      </p>
                    </div>
                  </div>
                </button>
              </div>
            </div>
          </div>}
        {/* Transactions Tab */}
        {activeTab === 'transactions' && <div className="mt-6" data-id="element-917">
            <h2 className="text-lg font-medium text-gray-900 mb-4" data-id="element-918">
              Recent Transactions
            </h2>
            <div className="bg-white shadow overflow-hidden sm:rounded-lg" data-id="element-919">
              <div className="overflow-x-auto" data-id="element-920">
                <table className="min-w-full divide-y divide-gray-200" data-id="element-921">
                  <thead className="bg-gray-50" data-id="element-922">
                    <tr data-id="element-923">
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-924">
                        Transaction
                      </th>
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-925">
                        Date
                      </th>
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-926">
                        Wallet
                      </th>
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-927">
                        Amount
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200" data-id="element-928">
                    {recentTransactions.map(transaction => <tr key={transaction.id} data-id="element-929">
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-930">
                          <div className="flex items-center" data-id="element-931">
                            <div className={`flex-shrink-0 h-8 w-8 rounded-full flex items-center justify-center ${transaction.type === 'credit' ? 'bg-green-100' : 'bg-red-100'}`} data-id="element-932">
                              {transaction.type === 'credit' ? <ArrowUpRight className={`h-4 w-4 ${transaction.type === 'credit' ? 'text-green-600' : 'text-red-600'}`} data-id="element-933" /> : <ArrowDownRight className={`h-4 w-4 ${transaction.type === 'credit' ? 'text-green-600' : 'text-red-600'}`} data-id="element-934" />}
                            </div>
                            <div className="ml-4" data-id="element-935">
                              <div className="text-sm font-medium text-gray-900" data-id="element-936">
                                {transaction.description}
                              </div>
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-937">
                          <div className="text-sm text-gray-900" data-id="element-938">
                            {transaction.date}
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-939">
                          <div className="text-sm text-gray-900" data-id="element-940">
                            {transaction.wallet}
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-941">
                          <div className={`text-sm font-medium ${transaction.type === 'credit' ? 'text-green-600' : 'text-red-600'}`} data-id="element-942">
                            {transaction.type === 'credit' ? '+' : '-'}{' '}
                            {getCurrencySymbol(transaction.currency)}
                            {transaction.amount.toFixed(2)}
                          </div>
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>
              <div className="bg-white px-4 py-3 border-t border-gray-200 text-center" data-id="element-943">
                <button className="text-sm font-medium text-blue-600 hover:text-blue-500" data-id="element-944">
                  View all transactions
                </button>
              </div>
            </div>
          </div>}
        {/* Exchange Tab */}
        {activeTab === 'exchange' && <div className="mt-6" data-id="element-945">
            <h2 className="text-lg font-medium text-gray-900 mb-4" data-id="element-946">
              Currency Exchange
            </h2>
            <div className="bg-white shadow overflow-hidden sm:rounded-lg" data-id="element-947">
              <div className="px-4 py-5 sm:p-6" data-id="element-948">
                <form data-id="element-949">
                  <div className="grid grid-cols-1 gap-6 sm:grid-cols-2" data-id="element-950">
                    <div data-id="element-951">
                      <label htmlFor="from-currency" className="block text-sm font-medium text-gray-700" data-id="element-952">
                        From
                      </label>
                      <div className="mt-1" data-id="element-953">
                        <select id="from-currency" name="from-currency" className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md" data-id="element-954">
                          {wallets.map(wallet => <option key={`from-${wallet.id}`} value={wallet.currency} data-id="element-955">
                              {wallet.currency} Wallet (
                              {getCurrencySymbol(wallet.code)}
                              {wallet.balance.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        })}
                              )
                            </option>)}
                        </select>
                      </div>
                    </div>
                    <div data-id="element-956">
                      <label htmlFor="to-currency" className="block text-sm font-medium text-gray-700" data-id="element-957">
                        To
                      </label>
                      <div className="mt-1" data-id="element-958">
                        <select id="to-currency" name="to-currency" className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md" data-id="element-959">
                          {wallets.map(wallet => <option key={`to-${wallet.id}`} value={wallet.currency} data-id="element-960">
                              {wallet.currency} Wallet
                            </option>)}
                        </select>
                      </div>
                    </div>
                    <div data-id="element-961">
                      <label htmlFor="amount" className="block text-sm font-medium text-gray-700" data-id="element-962">
                        Amount
                      </label>
                      <div className="mt-1 relative rounded-md shadow-sm" data-id="element-963">
                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-964">
                          <span className="text-gray-500 sm:text-sm" data-id="element-965">$</span>
                        </div>
                        <input type="text" name="amount" id="amount" className="focus:ring-blue-500 focus:border-blue-500 block w-full pl-7 pr-12 sm:text-sm border-gray-300 rounded-md" placeholder="0.00" data-id="element-966" />
                        <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" data-id="element-967">
                          <span className="text-gray-500 sm:text-sm" data-id="element-968">USD</span>
                        </div>
                      </div>
                    </div>
                    <div data-id="element-969">
                      <label htmlFor="exchange-rate" className="block text-sm font-medium text-gray-700" data-id="element-970">
                        Exchange Rate
                      </label>
                      <div className="mt-1" data-id="element-971">
                        <div className="px-4 py-2 bg-gray-50 text-gray-900 rounded-md border border-gray-300 text-sm" data-id="element-972">
                          1 USD = 0.79 GBP (Our rate: 0.78)
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-6" data-id="element-973">
                    <div className="bg-gray-50 p-4 rounded-md border border-gray-300" data-id="element-974">
                      <div className="flex justify-between items-center" data-id="element-975">
                        <div data-id="element-976">
                          <p className="text-sm font-medium text-gray-700" data-id="element-977">
                            You send
                          </p>
                          <p className="text-lg font-semibold text-gray-900" data-id="element-978">
                            $100.00
                          </p>
                        </div>
                        <div className="text-center" data-id="element-979">
                          <Repeat className="h-5 w-5 text-gray-400 mx-auto" data-id="element-980" />
                          <p className="text-xs text-gray-500 mt-1" data-id="element-981">
                            Exchange Rate
                          </p>
                          <p className="text-xs font-medium text-gray-700" data-id="element-982">
                            1 USD = 0.78 GBP
                          </p>
                        </div>
                        <div className="text-right" data-id="element-983">
                          <p className="text-sm font-medium text-gray-700" data-id="element-984">
                            Recipient gets
                          </p>
                          <p className="text-lg font-semibold text-gray-900" data-id="element-985">
                            £78.00
                          </p>
                        </div>
                      </div>
                      <div className="mt-4 border-t border-gray-200 pt-4" data-id="element-986">
                        <div className="flex justify-between text-sm" data-id="element-987">
                          <p className="text-gray-500" data-id="element-988">Fee</p>
                          <p className="text-gray-900" data-id="element-989">$1.00</p>
                        </div>
                        <div className="flex justify-between text-sm mt-1" data-id="element-990">
                          <p className="text-gray-500" data-id="element-991">Total</p>
                          <p className="text-gray-900 font-semibold" data-id="element-992">$101.00</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-6" data-id="element-993">
                    <button type="submit" className="w-full inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-994">
                      Exchange Currency
                    </button>
                  </div>
                </form>
              </div>
            </div>
            {/* Exchange Rates Table */}
            <div className="mt-8" data-id="element-995">
              <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-996">
                Current Exchange Rates
              </h3>
              <div className="bg-white shadow overflow-hidden sm:rounded-lg" data-id="element-997">
                <div className="overflow-x-auto" data-id="element-998">
                  <table className="min-w-full divide-y divide-gray-200" data-id="element-999">
                    <thead className="bg-gray-50" data-id="element-1000">
                      <tr data-id="element-1001">
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1002">
                          Currency Pair
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1003">
                          Rate
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1004">
                          Inverse Rate
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200" data-id="element-1005">
                      <tr data-id="element-1006">
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-1007">
                          USD / GBP
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1008">
                          0.79
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1009">
                          1.26
                        </td>
                      </tr>
                      <tr data-id="element-1010">
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-1011">
                          USD / NGN
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1012">
                          815.75
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1013">
                          0.00123
                        </td>
                      </tr>
                      <tr data-id="element-1014">
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-1015">
                          USD / ZAR
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1016">
                          18.65
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1017">
                          0.054
                        </td>
                      </tr>
                      <tr data-id="element-1018">
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-1019">
                          USD / GHS
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1020">
                          12.45
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1021">
                          0.080
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>}
      </div>
    </div>;
};
export default Wallets;